import { combineReducers } from 'redux';

// Front
import LayoutReducer from './layouts/reducer';

// Authentication
import LoginReducer from './auth/login/reducer';
import AccountReducer from './auth/register/reducer';
import ForgetPasswordReducer from './auth/forgetpwd/reducer';
import ProfileReducer from './auth/profile/reducer';
import UserReducer from './auth/user/reducer';
import ProductReducer from './product';
import ProductInventoryReducer from './productInventory/reducer';
import ProductOptionReducer from './productOption/reducer';
import PromotionsReducer from './promotions/reducer';
import EcommerceReducer from './ecommerce/reducer';
import InfoReducer from './info/reducer';
import CommonReducer from './common';
import CategoryReducer from './category/reducer';
import tagsReducer from './tags/reducer';
import CustomerReducer from './customer/reducer';
import LocationsReducer from './locations/reducer';
import ExportDataReducer from './exportData/reducer';
import EditSessionReducer from './editSession/reducer';
import TimeAttendanceReducer from './timeAttendance/reducer';

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Product: ProductReducer,
  ProductInventory: ProductInventoryReducer,
  ProductOption: ProductOptionReducer,
  Promotions: PromotionsReducer,
  User: UserReducer,
  Ecommerce: EcommerceReducer,
  Info: InfoReducer,
  Category: CategoryReducer,
  ExportData: ExportDataReducer,
  Tags: tagsReducer,
  Customer: CustomerReducer,
  Locations: LocationsReducer,
  TimeAttendance: TimeAttendanceReducer,
  Common: CommonReducer,
  EditSession: EditSessionReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
